import React from 'react'
import { Card } from './ui/card'
import { Button } from './ui/button'
import { Link } from 'react-router-dom'
import { useLanguage } from '../LanguageProvider'

type Lang = 'tr' | 'en'
type Localized<T> = Record<Lang, T>

type DevBoard = {
  slug: string
  name: Localized<string>
  image: string
  description: Localized<string>
}

const texts: Record<Lang, { heroTitle: string; viewDetails: string }> = {
  tr: {
    heroTitle: 'Geliştirme Kartları',
    viewDetails: 'Detayları Görüntüle',
  },
  en: {
    heroTitle: 'Development Boards',
    viewDetails: 'View Details',
  },
}

export function DevBoardsPage() {
  const { language } = useLanguage()
  const t = texts[language] ?? texts.tr
  const getLocalized = <T,>(value: Localized<T>): T => value[language] ?? value.tr

  const boards: DevBoard[] = [
    {
      slug: 'ardugsm',
      name: {
        tr: 'ArduGSM',
        en: 'ArduGSM',
      },
      image: 'arduGSM-1.png',
      description: {
        tr: 'ArduGSM, Arduino UNO (Atmega328P), SIM800C GSM modülü, 2 adet röle ve buzzer barındıran tümleşik bir kontrol kartıdır. Dahili 3A regülatör sayesinde güvenilir güç bağlantısı sağlar. Type-C USB konnektörü ile Arduino kolayca programlanabilir.',
        en: 'ArduGSM is an integrated control board that includes Arduino UNO (ATmega328P), SIM800C GSM module, 2 relays and a buzzer. Thanks to its built-in 3A regulator, it provides a reliable power connection. It can be easily programmed with Arduino via a Type-C USB connector.',
      },
    },
    {
      slug: 'esp32-ethernet-devboard',
      name: {
        tr: 'ESP32 Ethernet Devboard',
        en: 'ESP32 Ethernet Devboard',
      },
      image: 'esp32-eth_devboard.png',
      description: {
        tr: 'ESP32 Ethernet Geliştirme Modülü, Wi-Fi, Ethernet ve Bluetooth bağlantısını destekleyen, endüstriyel IoT projeleri için tasarlanmış bir geliştirme kartıdır. Dahili LAN8720 tabanlı Ethernet PHY arayüzü sayesinde doğrudan RJ45 portu üzerinden kablolu ağ bağlantısı sağlar. USB Type-C üzerinden programlanabilir ve Arduino IDE veya PlatformIO ortamında kolayca kullanılabilir.',
        en: 'ESP32 Ethernet Development Module is a development board designed for industrial IoT projects, supporting Wi‑Fi, Ethernet and Bluetooth connectivity. With its built-in LAN8720-based Ethernet PHY interface, it provides wired network connection directly via RJ45 port. It can be programmed over USB Type‑C and easily used with Arduino IDE or PlatformIO.',
      },
    },
    {
      slug: 'ilimflight-pro',
      name: {
        tr: 'ilimFlight Pro Drone Kontrol Kartı',
        en: 'ilimFlight Pro Drone Control Board',
      },
      image: 'ilimFlight-Pro-gribg.png',
      description: {
        tr: 'ilimFlight Pro, ArduPilot destekleyen tüm araç tiplerinde (multikopter, sabit kanat, helikopter, rover, bot vb.) profesyonel seviyede yüksek doğruluk ve güvenilirlikle çalışmak üzere tasarlanmış, son nesil bir uçuş kontrol bilgisayarıdır.',
        en: 'ilimFlight Pro is a next‑generation flight control computer designed to operate with high accuracy and reliability on all vehicle types supported by ArduPilot (multicopter, fixed‑wing, helicopter, rover, boat, etc.).',
      },
    },
  ]

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-foreground mb-8">{t.heroTitle}</h1>
        <div className="grid grid-cols-1 gap-6">
          {boards.map((board) => (
            <Card key={board.slug} className="overflow-hidden w-full max-w-4xl mx-auto">
              <div className="flex items-center p-6 gap-6">
                <div className="w-48 h-32 flex-shrink-0">
                  <Link to={`/urunler/gelistirme-kartlari/${board.slug}`}>
                    <img
                      src={`/${board.image}`}
                      alt={getLocalized(board.name)}
                      className="w-full h-full object-cover rounded-md"
                    />
                  </Link>
                </div>
                <div className="flex-1">
                  <Link
                    to={`/urunler/gelistirme-kartlari/${board.slug}`}
                    className="hover:text-primary transition-colors"
                  >
                    <h3 className="text-xl font-semibold text-foreground mb-1">
                      {getLocalized(board.name)}
                    </h3>
                  </Link>
                  <p className="text-sm text-muted-foreground">
                    {getLocalized(board.description)}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <Link to={`/urunler/gelistirme-kartlari/${board.slug}`}>
                    <Button variant="outline" size="sm">
                      {t.viewDetails}
                    </Button>
                  </Link>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}


